<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-12">
        <span class="h2">{{ solicitacao.pessoa.tps_tipo | tipoPessoaTabNumero }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h5>Dados Pessoais</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <b-form-group label="CPF/CNPJ">
          <h6 class="mb-3" v-if="solicitacao.pessoa.tps_cpf_cnpj.length < 12">
            {{ solicitacao.pessoa.tps_cpf_cnpj | VMask('###.###.###-##') }}</h6>
          <h6 class="mb-3" v-else>{{ solicitacao.pessoa.tps_cpf_cnpj | VMask('##.###.###/####-##') }}</h6>
        </b-form-group>
      </div>
      <div class="col-md-5">
        <b-form-group label="Nome/Razão Social">
          <h6 class="mb-3">{{ solicitacao.pessoa.tps_razao_social_nome }}</h6>
        </b-form-group>
      </div>
      <div class="col-md-3">
        <b-form-group label="Nascimento/Abertura">
          <h6 class="mb-3">{{ solicitacao.pessoa.tps_data_abertura_nascimento | formatDate }}</h6>
        </b-form-group>
      </div>
    </div>
    <div v-if="solicitacao.pessoa.tps_tipo ==='1' || solicitacao.pessoa.tps_tipo ==='2'">
      <div class="row">
        <div class="col-md-3">
          <b-form-group label="Núm. RG">
            <h6 class="mb-3">{{ solicitacao.pessoa.tps_rg }}</h6>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group label="Órgão emissor RG">
            <h6 class="mb-3">{{ solicitacao.pessoa.tps_orgaoemissor }}</h6>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="Natureza Jurídica">
            <h6 class="mb-3">
              [{{ solicitacao.pessoa.tps_natureza_juridica.naj_referencia }}]
              {{ solicitacao.pessoa.tps_natureza_juridica.naj_descricao }}
            </h6>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <b-form-group label="PIS/PASEP">
            <h6 class="mb-3">{{ solicitacao.pessoa.tps_pispasep | naoInformado }}</h6>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group label="Título eleitoral">
            <h6 class="mb-3">{{ solicitacao.pessoa.tps_tituloeleitor | naoInformado }}</h6>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group label="Sexo">
            <h6 class="mb-3">{{ solicitacao.pessoa.sexo }}</h6>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group label="Estado Civil">
            <h6 class="mb-3">{{ solicitacao.pessoa.tps_estadocivil | naoInformado }}</h6>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <b-form-group label="Nível de Escolaridade">
            <h6 class="mb-3">{{ solicitacao.pessoa.tps_escolaridade | naoInformado }}</h6>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="Classe Profissional">
            <h6 class="mb-3">{{ solicitacao.pessoa.tps_sociedade_classe | naoInformado }}</h6>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group label="Núm. Registro de Classe">
            <h6 class="mb-3">{{ solicitacao.pessoa.tps_numero_registro_classe | naoInformado }}</h6>
          </b-form-group>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-md-6">
          <b-form-group label="Nome Fantasia">
            <h6 class="mb-3">{{ solicitacao.pessoa.tps_nome_fantasia }}</h6>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="Natureza Jurídica">
            <h6 class="mb-3">
              [{{ solicitacao.pessoa.tps_natureza_juridica.naj_referencia }}]
              {{ solicitacao.pessoa.tps_natureza_juridica.naj_descricao }}
            </h6>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <b-form-group label="Tipo de Estabelecimento">
            <h6 class="mb-3">
              {{ solicitacao.pessoa.tps_tipo_estabelecimento | estabelecimentoPessoa | naoInformado }}</h6>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group label="Porte">
            <h6 class="mb-3">
              {{ solicitacao.pessoa.tps_porte | portePessoa | naoInformado }}
            </h6>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group label="Inscrição Estadual">
            <h6 class="mb-3">
              {{ solicitacao.pessoa.tps_inscricao_estadual | naoInformado }}
            </h6>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <b-form-group label="Inscrição Municipal">
            <h6 class="mb-3">
              {{ solicitacao.pessoa.tps_inscricaomunicipal | naoInformado }}
            </h6>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group label="Capital Social">
            <h6 class="mb-3">{{ solicitacao.pessoa.tps_capital_social | formatNumeroBr }}</h6>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="Tributação Informada">
            <h6 class="mb-3">
              <span class="text-dark font-weight-bold">{{ solicitacao.pessoa.tps_tributacao | tributacaoPessoa }}</span>
            </h6>
          </b-form-group>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <b-form-group label="Início das Atividades no Município">
          <h6 class="mb-3">
            {{ solicitacao.pessoa.tps_data_inicio | formatDate }}
          </h6>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h5>Contato</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-md-5">
        <b-form-group label="E-mail">
          <table class="table mb-0">
            <tbody>
            <tr v-for="e in solicitacao.emails" v-bind:key="e.tem_codigo">
              <td>{{ e.tem_email }}</td>
            </tr>
            </tbody>
          </table>
        </b-form-group>
      </div>
      <div class="col-md-7">
        <b-form-group label="Telefones">
          <table class="table mb-0">
            <tbody>
            <tr v-for="t in solicitacao.telefones" v-bind:key="t.tfo_codigo">
              <td>{{ t.tet_codigo.tab_nome }} - {{ t.tfo_contato }} {{ t.tfo_numero }}</td>
            </tr>
            </tbody>
          </table>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h5>Endereços</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <table class="table mb-0">
          <tbody>
          <tr v-for="end in solicitacao.enderecos" v-bind:key="end.ted_codigo">
            <td>
              {{ end.ted_tipo.tab_nome }} - {{ end.ted_logradouro }}, Nº {{ end.ted_numero }},
              {{ end.ted_complemento }}, {{ end.ted_bairro }}, {{ end.mun_nome }}-{{ end.mun_uf }},
              CEP {{ end.ted_cep }}. {{ end.ted_ponto_referencia }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-if="solicitacao.cnae && solicitacao.cnae.length > 0">
      <div class="row">
        <div class="col-md-12">
          <h5>Cnae</h5>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <table class="table mb-0">
            <tbody>
            <tr v-for="c in solicitacao.cnae" v-bind:key="c.tpc_codigo">
              <td>
                {{ c.cnae_codigo }} - {{ c.cnae_nome }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div v-if="solicitacao.servicos && solicitacao.servicos.length > 0">
      <div class="row">
        <div class="col-md-12">
          <h5>Atividades</h5>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <table class="table mb-0">
            <tbody>
            <tr v-for="s in solicitacao.servicos" v-bind:key="s.tat_codigo">
              <td>
                {{ s.ser_codigo }} - {{ s.ser_descricao }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <h5>Contador</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h6 v-if="solicitacao.economico.tec_contador_proprio === 'S'" class="mb-3">É o próprio contador</h6>
        <div v-if="solicitacao.economico.tec_contador_proprio === 'N' && solicitacao.economico.contador" class="row">
          <div class="col-md-6">
            <b-form-group label="Nome">
              <h6 class="mb-3">{{ solicitacao.economico.contador.pes_nome }}</h6>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="CPF">
              <h6 class="mb-3">
                {{ solicitacao.economico.contador.pes_cpfcnpj | VMask('###.###.###-##') }}
              </h6>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="CRC">
              <h6 class="mb-3">
                {{ solicitacao.economico.contador.pes_numero_registro_classe }}
              </h6>
            </b-form-group>
          </div>
        </div>
        <h6 v-if="solicitacao.economico.tec_contador_proprio === 'N' && !solicitacao.economico.contador" class="mb-3">
          Não Informado</h6>
      </div>
    </div>

    <div v-if="solicitacao.socio && solicitacao.socio.length > 0">
      <div class="row">
        <div class="col-md-12">
          <h5>Socios</h5>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <table class="table mb-0">
            <tbody>
            <tr v-for="s in solicitacao.socio" v-bind:key="s.tps_codigo">
              <td>
                {{ s.tps_cpf_cnpj | VMask('###.###.###-##') }} - {{ s.tps_razao_social_nome }}<br>
                Tipo: {{ s.qualificacao }}<br>
                Representante: {{ s.tms_representante | s_NtoText }}<br>
                Participação: {{ s.tms_participacao }}%
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div v-if="solicitacao.tabeliao">
      <div class="row">
        <div class="col-md-12">
          <h5>Tabelião</h5>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <table v-if="solicitacao.tabeliao" class="table mb-0">
            <tbody>
            <tr>
              <td>
                {{ solicitacao.tabeliao.tps_cpf_cnpj | VMask('###.###.###-##') }} -
                {{ solicitacao.tabeliao.tps_razao_social_nome }} -
                {{ solicitacao.tabeliao.tps_mail }} -
                <span v-for="t in solicitacao.tabeliao_telefone" v-bind:key="t.tfo_codigo">
                        {{ t.tet_codigo.tab_nome }}: {{ t.tfo_numero | VMask('(##) #### ####?#') }}
                      </span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <h5>Usuário Solicitante</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <b-form-group label="Nome">
          <h6 class="mb-3">{{ solicitacao.usuario.pes_nome }}</h6>
        </b-form-group>
      </div>
      <div class="col-md-3">
        <b-form-group label="CPF">
          <h6 class="mb-3">{{ solicitacao.usuario.pes_cpfcnpj | VMask('###.###.###-##') }}</h6>
        </b-form-group>
      </div>
      <div class="col-md-3">
        <b-form-group label="E-mail">
          <h6 class="mb-3">{{ solicitacao.usuario.pes_mail }}</h6>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "liberacao-detalhe",
  props: {
    solicitacao: {
      type: Object,
    },
  },
}
</script>

<style scoped>

</style>
